import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches the admin-chosen cover photo for each service slug.
 * Returns a map: { btp: url, sports: url, ... } where url is the WATERMARK-FREE
 * variant when available (for the home disciplines grid), with fallback to the
 * watermarked variant for legacy uploads.
 *
 * Components consuming this typically combine the result with `SERVICES[i].cover`
 * (the built-in static fallback) so the UI never breaks if a service has no
 * admin-uploaded cover yet.
 */
export function useServiceCovers() {
  const [covers, setCovers] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND}/api/portfolio-service-covers`);
        const data = await r.json();
        if (cancelled) return;
        const mapped = {};
        Object.entries(data || {}).forEach(([slug, doc]) => {
          if (!doc) return;
          // STRICT: the home disciplines grid must never show watermarked
          // photos. We only use covers that have a clean variant — legacy
          // uploads fall through to the static SERVICES[i].cover fallback.
          if (!doc.clean_url) return;
          mapped[slug] = `${BACKEND}${doc.clean_url}`;
        });
        setCovers(mapped);
        setLoaded(true);
      } catch {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { covers, loaded };
}
